import React from "react";
import { Button, Container, Hero, Row } from "../components";

const HeroPage: React.FC = () => (
  <Hero>
    <Container>
      <Row>
        <Hero.Content>
          <Hero.Welcome>Hello, I'm</Hero.Welcome>
          <Hero.Name>Ahmed Zaki BENNECER</Hero.Name>
          <Hero.Role>Frontend Developer</Hero.Role>
          <Button to='About'>More about me</Button>
          <Button to='Portfolio'>Portfolio</Button>
        </Hero.Content>
        <Hero.Image />
      </Row>
    </Container>
  </Hero>
);

export default HeroPage;
